import { queryOptions, useQuery } from '@tanstack/react-query';
import { viewQueryKeys } from '@/features/views/queryKeys';
import { VisualizationApi } from '@/features/visualizations/api/visualization';

export const getVisualizationsQueryOptions = ({
  loopId,
  viewId,
}: {
  orgId?: string;
  loopId: number;
  viewId: number;
}) =>
  queryOptions({
    queryKey: viewQueryKeys.visualizations.all(loopId, viewId),
    queryFn: () => VisualizationApi.fetchAllVisualizations(viewId),
    enabled: !!loopId && !!viewId,
  });

export const useLoopViewVisualizations = ({
  orgId,
  loopId,
  viewId,
}: {
  orgId: string;
  loopId: number;
  viewId: number;
}) => {
  return useQuery({
    ...getVisualizationsQueryOptions({ orgId, loopId, viewId }),
    enabled: !!loopId && !!viewId,
  });
};
